import { render } from "./Part.vue?vue&type=template&id=1b8ce2ce"
import script from "./Part.vue?vue&type=script&lang=js"
export * from "./Part.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__